<template>
  <div class="pass">
    <title-bar-back :title="'修改密码'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 修改登录密码 border_bottom1px -->
    <div class="item_item clearfix" @click="goSecurity">
      <div class="left font14 font_weight400 colo0 ">修改登录密码</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div
        :class="getUserInfo.password ? 'all_right' : 'right_det'"
        class="right font14 font_weight400"
      >
        {{ getUserInfo.password ? "已设置" : "未设置" }}
      </div>
    </div>
    <!-- 修改支付密码 -->
    <!-- <div class="item_item clearfix">
      <div class="left font14 font_weight400 colo0 ">修改支付密码</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go right"
      />
      <div
        :class="true ? 'all_right' : 'right_det'"
        class="right font14 font_weight400"
      >
        已设置
      </div>
    </div> -->
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "ModifyPassword",
  components: {
    TitleBarBack
  },
  data() {
    return {};
  },
  computed: {
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  created() {
    if (!this.getUserInfo.username) {
      this.getData();
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    getData() {
      // getUserInfo
      this.$store
        .dispatch("mine/getUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    goSecurity() {
      this.$router.push({
        path: "/mine/securitycheck",
        query: {
          where: "modifyPass"
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.pass {
  // background: #fff;
  // position: fixed;
  // top: 0;
  // right: 0;
  // left: 0;
  // bottom: 0;
  .item_item {
    background: #fff;
    padding: 14px 12px;
    line-height: 24px;
    .right_det {
      color: rgba(0, 0, 0, 0.55);
    }
    .all_right {
      color: #bf9264;
    }
    .right_go {
      // margin-top: 17px;
      width: 24px;
    }
    .right_chart {
      color: #bf9264;
    }
  }
}
</style>
